/**
 * Piano configuration.
 *
 * @type {{}}
 */
window.PianoUtils = {

	BASIC_CONF: {
		site: 573941,
		collectDomain: 'https://logs1407.xiti.com',
	},

	proxy_eventsList: null,
	proxy_sendEventCore: null,

	initPianoMode: function (confirmed, consent) {
		// PA privacy not loaded.
		if (PianoUtils.isPaPrivacyUndefined()) {
			return;
		}

		// If no user explicit choice, define cnilExempt.
		if (!confirmed) {
			return PianoUtils.cnilExempt();
		}

		// If use explicit consent.
		if (consent) {
			return PianoUtils.setOptin();
		}

		PianoUtils.setOptout();

	},

	/**
	 * Init piano data, when no optin and no opt out yet.
	 */
	cnilExempt: function () {
		if (this.isPaPrivacyUndefined()) {
			return;
		}

		pa.privacy.setMode('exempt', 'cnil');
		this.initExemptProperties();
	},

	/**
	 * Opt In.
	 */
	setOptin: function () {
		if (this.isPaPrivacyUndefined()) {
			return;
		}

		pa.privacy.setMode('optin');
		this.initExemptProperties();
	},

	/**
	 * Opt Out.
	 */
	setOptout: function () {
		if (this.isPaPrivacyUndefined()) {
			return;
		}

		pa.privacy.setMode('optout');
	},

	/**
	 * Init exempt properties (for optin and cnil exmeption).
	 */
	initExemptProperties: function () {
		if (this.isPaPrivacyUndefined()) {
			return;
		}

		pa.privacy.include.property('site_level2', ['exempt']);
		pa.privacy.include.property('organisme', ['exempt']);
	},

	/**
	 * Return true if Pa object is not ready yet.
	 * @returns {boolean}
	 */
	isPaUndefined: () => typeof window.pa === 'undefined',

	/**
	 * Return true if Pa privacy object is not ready yet.
	 * @returns {boolean}
	 */
	isPaPrivacyUndefined: () => typeof window.pa?.privacy?.getMode === 'undefined',

	/**
	 * Add poxy for pa.sendEvent, in order to stock pa events triggered before CMP initialisation.
	 */
	addProxy() {
		this.proxy_sendEventCore = window.pa.sendEvent;
		this.proxy_eventsList = [];
		window.pa.sendEvent = function (...data) {
			PianoUtils.proxy_eventsList.push(data);
		}
	},

	/**
	 * Remove  pa.sendEvent procy, and trigger events after CMP initialisation.
	 */
	removeProxy() {
		if (this.proxy_sendEventCore && this.proxy_eventsList) {
			window.pa.sendEvent = this.proxy_sendEventCore;
			this.proxy_eventsList.map((data) => window.pa.sendEvent(...data));
			this.proxy_eventsList = this.proxy_sendEventCore = null;
		}
	},
}

// Init Pa Configuration at load.
window.pa?.setConfigurations(window.PianoUtils.BASIC_CONF)

// Init proxy pa in order to send events only when CMP hs been initialized.
PianoUtils.addProxy();

export const orejime_apps_piano = {
	name: "pianoanalytics",
	title: "Mesure d'audience",
	default: false,
	description: "Ces cookies permettent de générer des statistiques anonymes de fréquentation du site via Piano Analytics (le nombre de visites, les pages les plus vues, etc.) Ces données contribuent à identifier d’éventuels dysfonctionnements sur le site et à améliorer la qualité de nos services.",
	cookies: [
		"_pcid",
		"_pctx",
		"pa_user",
		"pa_privacy",
	],
	callback: (consent, app) => {
		PianoUtils.initPianoMode(window.orejime_instance?.isConfirmed(app.name), consent);
		PianoUtils.removeProxy();
	}
};
